import React, {useEffect} from 'react'
import PropTypes from "prop-types";
import {useI18nContext} from "../../i18n/I18nContext";
import MethodTitle from "../../misc/Method-title/MethodTitle";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";
import toast from "../../../assets/illustrations/illu-toast.svg";
import Text from "../../i18n/Text";
import LOG from "wipi-common/src/lib/logging/logger";
import {LOG_EVENTS} from "wipi-common/src/lib/logging/events";

export default function EudiwIdError({caseInfo}) {
    const context = useI18nContext();

    useEffect(() => {
        LOG.logInfo(LOG_EVENTS.EW_ERROR)
    }, []);

    return (
        <>
            <div className="headless">
                <div className="col-xl-6 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 col-12">
                    <div className="row max-w-75 mx-auto">
                        <MethodTitle
                            heading={getI18nTextWithContext(context, 'startEudiwId.heading')}
                            subHeading={null}
                            info={null}
                            testId="h456wi41a4p9"/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column align-items-center justify-content-center">
                        <img src={toast} alt="verified" className="m-4 mw-100"
                             style={{width: '80px'}} data-test-id="34anlf24qvsc4"/>
                        {getI18nTextWithContext(context, 'unexpectedError.error')}
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column align-items-center justify-content-center">
                        <button className="btn btn-primary btn-block mb-2" data-test-id="a2b810f4-938c">
                            <Text k="eudiwIdError.button.other"/>
                        </button>
                        <button className="btn btn-primary btn-block" data-test-id="a2f110f4-948c">
                            <Text k="common.tryAgain"/>
                        </button>


                    </div>
                </div>
            </div>
        </>
    );
}

EudiwIdError.propTypes = {
    caseInfo: PropTypes.object.isRequired
}